module.exports = __webpack_public_path__ + "img/multiplayer-game-server-client-process.556763da.jpg";